import React from "react";
import { useParams } from "react-router-dom";
import CheckoutView from "../views/users/CheckoutView";

const Checkout: React.FC = () => {
    const { cartId } = useParams();

    return <div>
        <CheckoutView cartId={Number(cartId)} />
    </div>;
};

export default Checkout;